import { createContext, useContext, useState } from "react";
import { api } from "../Assets/api/api";
import { getUserLanguage } from "../utils/i18n";
import i18n from "../helper/i18n";
import { toast } from "react-toastify";

const MagicBar = createContext();

export const useMagicBar = () => {
  return useContext(MagicBar);
};

export const MagicBarProvider = (props) => {
  const { user, setUser } = props;

  const [isGeneratingAssignment, setIsGeneratingAssignment] = useState(false);
  const [isGeneratingRubrics, setIsGeneratingRubrics] = useState(false);

  const generateAssignmentData = async (topic, textAttachment) => {
    const payload = {
      topic,
      generateTextAttachment: textAttachment,
      language: getUserLanguage(i18n.language),
    };
    try {
      setIsGeneratingAssignment(true);
      const response = await api.post(
        `/api/gpt/generate-assignment-content${user.slug}`,
        payload
      );

      if (response.data.success) {
        setUser({
          ...user,
          credit: user.credit - response.data.deductedCredits,
        });
        return response.data.data;
      }

      return null;
    } catch (error) {
      console.log("generateAssignmentData error:", error);
      
      toast.error("Failed to generate assignment. Please try again later.");
    } finally {
      setIsGeneratingAssignment(false);
    }
  };

  const generateRubric = async (payload) => {
    try {
      setIsGeneratingRubrics(true);
      const response = await api.post(
        `/api/gpt/generate-assignment-rubrics${user.slug}`,
        payload
      );
      if (response.data.success) {
        setUser({
          ...user,
          credit: user.credit - response.data.deductedCredits,
        });
        return response.data.data;
      }

      return null;
    } catch (error) {
      toast.error("Failed to generate rubrics. Please try again later.");
    } finally {
      setIsGeneratingRubrics(false);
    }
  };

  return (
    <MagicBar.Provider
      value={{
        user,
        isGeneratingAssignment,
        generateAssignmentData,
        isGeneratingRubrics,
        generateRubric,
      }}
    >
      {props.children}
    </MagicBar.Provider>
  );
};
